import { createRouter, createWebHashHistory } from 'vue-router';
import MortgageDetailsView from '../views/MortgageDetailsView.vue';
import PropertyDetailsView from '../views/PropertyDetailsView.vue';
import CurrentMortgageView from '../views/CurrentMortgageView.vue';
import RemortgagingNeedsView from '../views/RemortgagingNeedsView.vue';
import YourDetailsView from '../views/YourDetailsView.vue';
import SubmissionConfirmationView from '../views/SubmissionConfirmationView.vue';

const router = createRouter({
	history: createWebHashHistory(),
	routes: [
		{
			path: '/mortgage/start',
			children: [
				{
					path: 'mortgage-details',
					name: 'mortgage-details',
					component: MortgageDetailsView,
				},
				{
					path: 'property-details',
					name: 'property-details',
					component: PropertyDetailsView,
					beforeEnter: (to, from) => {
						if (from.name !== 'property-details' && from.name !== 'mortgage-details' && !from.name) {
							return { name: 'mortgage-details' };
						}
					},
				},
				{
					path: 'current-mortgage',
					name: 'current-mortgage',
					component: CurrentMortgageView,
					beforeEnter: (to, from) => {
						if (from.name !== 'current-mortgage' && from.name !== 'mortgage-details' || !from.name) {
							return { name: 'mortgage-details' };
						}
					},
				},
				{
					path: 'remortgaging-needs',
					name: 'remortgaging-needs',
					component: RemortgagingNeedsView,
					beforeEnter: (to, from) => {
						if (from.name !== 'remortgaging-needs' && from.name !== 'current-mortgage' || !from.name) {
							return { name: 'mortgage-details' };
						}
					},
				},
				{
					path: 'your-details',
					name: 'your-details',
					component: YourDetailsView,
					beforeEnter: (to, from) => {
						if (from.name !== 'your-details' && from.name !== 'remortgaging-needs' && from.name !== 'property-details' || !from.name) {
							return { name: 'mortgage-details' };
						}
					}
				},
				{
					path: 'submitted',
					name: 'submitted',
					component: SubmissionConfirmationView,
					beforeEnter: (to, from) => {
						if (from.name !== 'submitted' && from.name !== 'your-details' || !from.name) {
							return { name: 'mortgage-details' };
						}
					}
				},
				{
					path: '/:pathMatch(.*)*',
					redirect: '/mortgage/start/mortgage-details',
				},
			],
		},
	],
	scrollBehavior(to, _from, savedPosition) {
		if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth'
			};
		}
		if (savedPosition) {
			return savedPosition;
		}
		return {
			top: 0
		};
	}
});

export default router;
